import React from "react";
import { Modal } from "react-bootstrap";
import { MOCK_TARIFFS } from "../mocks";

function Icon({ name, size = 20 }) {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (name) {
    case "check":
      return (
        <svg {...common}>
          <polyline points="20 6 9 17 4 12" />
        </svg>
      );
    case "spark":
      return (
        <svg {...common}>
          <path d="M12 2v4" />
          <path d="M12 18v4" />
          <path d="m4.93 4.93 2.83 2.83" />
          <path d="m16.24 16.24 2.83 2.83" />
          <path d="M2 12h4" />
          <path d="M18 12h4" />
          <path d="m4.93 19.07 2.83-2.83" />
          <path d="m16.24 7.76 2.83-2.83" />
        </svg>
      );
    default:
      return null;
  }
}

function TariffsSectionContent() {
  return (
    <>
      <div className="tariffGrid">
        {MOCK_TARIFFS.map((t) => (
          <div
            key={t.key}
            className={[
              "tariffCard",
              t.active ? "tariffCard--active" : "",
              t.comingSoon ? "tariffCard--soon" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {t.active && <div className="tariffCard__badge">Текущий тариф</div>}
            {t.comingSoon && (
              <div className="tariffCard__badge tariffCard__badge--soon">
                Скоро
              </div>
            )}
            <div className="tariffCard__name">{t.name}</div>
            <div className="tariffCard__price">
              {t.pricePerCashdesk ? (
                <>
                  <span className="tariffCard__priceValue">
                    {t.pricePerCashdesk.toLocaleString("ru-RU")}
                  </span>
                  <span className="tariffCard__priceUnit">
                    {" "}
                    сум / касса / мес
                  </span>
                </>
              ) : (
                <span className="tariffCard__priceUnit">Цена — скоро</span>
              )}
            </div>
            <ul className="tariffCard__features">
              {t.features.map((f) => (
                <li key={f}>
                  <Icon name="check" size={16} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="aboutCard mt-3">
        <div className="aboutCard__icon">
          <Icon name="spark" size={22} />
        </div>
        <div>
          <div className="aboutCard__title">Что мы делаем</div>
          <div className="aboutCard__text">
            Фискализация продаж, управление маркировкой, ИКПУ и данными товаров
            и услуг.
          </div>
        </div>
      </div>
    </>
  );
}

/**
 * @param {{ show: boolean; onHide: () => void }} props
 */
export default function TariffsModal({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      scrollable
      dialogClassName="appModalDialog appModalDialog--tariffs"
      contentClassName="appModalContent appModalContent--tariffs"
      backdropClassName="appModalBackdrop"
      size="lg"
    >
      <Modal.Header closeButton className="appModalContent__header">
        <Modal.Title as="h3" className="appModalContent__title m-0">
          Тарифы
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="appModalContent__body pt-2">
        <TariffsSectionContent />
      </Modal.Body>
    </Modal>
  );
}
